<template>
  <v-row>
    <v-col cols="12">
      <v-card flat rounded="lg">
        <v-card-subtitle class="font-weight-bold black--text subtitle-1"
          >Meus saldos</v-card-subtitle
        >
        <v-card-text>
          <v-row v-if="carregando">
            <v-col
              xl="3"
              lg="3"
              md="3"
              sm="12"
              cols="12"
              v-for="(num, i) in 4"
              :key="i"
            >
              <v-skeleton-loader
                class="mx-auto rounded-lg"
                max-height="150"
                min-width="200"
                type="image"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else-if="saldos.length == 0">
            <v-col cols="12">
              <v-alert type="info" text
                >Não há saldos disponíveis para serem exibidos</v-alert
              >
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col
              xl="3"
              lg="3"
              md="3"
              sm="12"
              cols="12"
              v-for="(saldo, index) in saldosParaExibir"
              :key="index"
            >
              <v-card
                outlined
                class="h-100 rounded-lg"
                :hover="getProps(saldo).hover && !gerencial"
                min-width="200"
                :color="getProps(saldo).cor + ' lighten-5'"
                @click="onPressedSaldo(saldo)"
              >
                <v-card-title
                  :class="
                    getProps(saldo).cor +
                    '--text text--darken-1 font-weight-bold'
                  "
                >
                  {{ saldo.descricao }}
                </v-card-title>

                <v-card-subtitle
                  :class="getProps(saldo).cor + '--text text--darken-1'"
                >
                  {{ saldo.subdescricao }}
                  <span
                    v-if="saldo.conta === '11'"
                    class="pa-0 d-block"
                    style="font-size: 0.6em; margin-top: -7px"
                  >
                    *Sujeito a análise de crédito.
                  </span>
                </v-card-subtitle>

                <v-card-text>
                  <p
                    v-if="saldo.conta !== 'LM'"
                    style="font-size: 1.4rem"
                    :class="
                      getProps(saldo).cor +
                      '--text text--darken-1 font-weight-bold'
                    "
                  >
                    {{ maskMoeda(saldo.saldo) }}
                  </p>
                  <p
                    v-else
                    style="font-size: 1rem"
                    :class="
                      getProps(saldo).cor +
                      '--text text--darken-1 font-weight-bold'
                    "
                  >
                    Limite atualizado {{ limiteMercadoDataAtual }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-dialog v-model="dialogLimiteMercado" max-width="520">
            <v-card class="lm-dialog" rounded="xl">
              <!-- HEADER -->
              <div class="lm-head">
                <div class="d-flex align-center">
                  <v-avatar size="42" class="lm-avatar">
                    <v-icon color="deep-purple" size="24"
                      >mdi-chart-timeline-variant</v-icon
                    >
                  </v-avatar>

                  <div class="ml-3">
                    <div class="lm-title">Limite conta consumo</div>
                    <div class="lm-subtitle">
                      Atualizado em
                      <strong>{{ limiteMercadoDataAtual }}</strong>
                    </div>
                  </div>
                </div>

                <v-btn
                  icon
                  class="lm-close"
                  @click="dialogLimiteMercado = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <!-- CONTENT -->
              <v-card-text class="pt-4">
                <!-- Destaque do mês atual -->
                <v-sheet
                  class="lm-highlight"
                  rounded="lg"
                  color="deep-purple lighten-5"
                >
                  <div class="d-flex align-center justify-space-between">
                    <div>
                      <div class="lm-highlight-title">Mês atual</div>
                      <div class="lm-highlight-date">
                        {{ limiteMercadoDataAtual }}
                      </div>
                    </div>
                    <v-chip small color="deep-purple" text-color="white">
                      Vigente
                    </v-chip>
                  </div>
                </v-sheet>

                <div class="lm-section-title mt-4 mb-2">
                  Calendário de atualizações
                </div>

                <!-- Lista estilo timeline -->
                <div class="lm-timeline">
                  <div
                    v-for="(item, idx) in limiteMercadoDatas"
                    :key="'lm-' + item.mes"
                    class="lm-row"
                  >
                    <div class="lm-dot-wrap">
                      <span
                        class="lm-dot"
                        :class="{ 'lm-dot--active': item.mes === mesAtual }"
                      />
                      <span
                        v-if="idx !== limiteMercadoDatas.length - 1"
                        class="lm-line"
                      />
                    </div>

                    <div class="lm-row-content">
                      <div class="lm-row-title">
                        Limite atualizado
                        <span class="lm-row-date">{{ item.data }}</span>
                      </div>

                      <v-chip
                        v-if="item.mes === mesAtual"
                        x-small
                        color="deep-purple"
                        text-color="white"
                        class="lm-chip"
                      >
                        Mês atual
                      </v-chip>
                    </div>
                  </div>
                </div>
              </v-card-text>

              <!-- ACTIONS -->
              <v-card-actions class="px-4 pb-4">
                <v-spacer />
                <v-btn
                  color="deep-purple"
                  class="white--text"
                  rounded
                  depressed
                  @click="dialogLimiteMercado = false"
                >
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <creditos-recebidos
            v-if="getCreditosRecebidos()"
            :creditos="getCreditosRecebidos().detalhe"
          />
          <gastos-conta-cliente v-if="getContasConsumo()" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { formatMoeda } from "@/global";
import CreditosRecebidos from "./CreditosRecebidos.vue";
import { mapMutations, mapState } from "vuex";
import GastosContaCliente from "./GastosContaCliente.vue";

export default {
  components: { CreditosRecebidos, GastosContaCliente },
  computed: {
    ...mapState("usuario", ["gerencial"]),
    mesAtual() {
      return new Date().getMonth() + 1;
    },
    limiteMercadoDataAtual() {
      const dataMesAtual = this.limiteMercadoDatas.find(
        (item) => item.mes === this.mesAtual,
      );
      return (dataMesAtual || this.limiteMercadoDatas[0]).data;
    },
    saldosParaExibir() {
      const lista = [...this.saldos];
      if (!lista.length) return lista;

      const cardLimiteMercado = {
        conta: "LM",
        descricao: "Limite conta consumo",
        subdescricao: `Limite atualizado ${this.limiteMercadoDataAtual}`,
        saldo: null,
      };

      const indexContaConsumo = lista.findIndex((saldo) => saldo.conta == "11");
      if (indexContaConsumo >= 0) {
        lista.splice(indexContaConsumo + 1, 0, cardLimiteMercado);
      } else {
        lista.splice(Math.max(lista.length - 1, 0), 0, cardLimiteMercado);
      }

      return lista;
    },
  },
  data: () => ({
    carregando: false,
    dialogLimiteMercado: false,
    saldos: [],
    limiteMercadoDatas: [
      { mes: 1, data: "21/01/2026" },
      { mes: 2, data: "18/02/2026" },
      { mes: 3, data: "18/03/2026" },
      { mes: 4, data: "22/04/2026" },
      { mes: 5, data: "20/05/2026" },
      { mes: 6, data: "17/06/2026" },
      { mes: 7, data: "22/07/2026" },
      { mes: 8, data: "19/08/2026" },
      { mes: 9, data: "16/09/2026" },
      { mes: 10, data: "21/10/2026" },
      { mes: 11, data: "18/11/2026" },
      { mes: 12, data: "16/12/2026" },
    ],
    cores: [
      { conta: "2", cor: "grey", hover: false },
      { conta: "87", cor: "green", hover: false },
      { conta: "11", cor: "blue", hover: false },
      { conta: "LM", cor: "deep-purple", hover: true },
      { conta: "37", cor: "orange", hover: true },
      { conta: "91", cor: "teal", hover: true },
      { conta: "90", cor: "cyan", hover: false },
    ],
  }),
  methods: {
    ...mapMutations("home", [
      "setDialogCredRecebidos",
      "setDialogGastosCliente",
      "setDialogGastosConsumo",
    ]),
    maskMoeda(value) {
      return formatMoeda(value, 2);
    },
    getCreditosRecebidos() {
      return this.saldos.find((saldo) => saldo.conta == "91");
    },
    getContasConsumo() {
      return this.saldos.find((saldo) => saldo.conta == "11");
    },
    getProps(saldo) {
      return (
        this.cores.find((cor) => cor.conta == saldo.conta) || {
          cor: "grey",
          hover: false,
        }
      );
    },
    onPressedSaldo(saldo) {
      if (saldo.conta == "LM") {
        this.dialogLimiteMercado = true;
        return;
      }

      if (this.gerencial) {
        return;
      }

      if (saldo.conta == 91) {
        this.setDialogCredRecebidos(true);
      } else if (saldo.conta == 37) {
        this.setDialogGastosCliente(true);
      } else if (saldo.conta == 11) {
        this.$router.push("limites-consumo");
      }
    },
    async getSaldosContas() {
      this.saldos = [];
      await axios
        .get(`/colaborador/financeiro?funcao=SALDOS-CONTAS`)
        .then((res) => {
          if (res.data.success) {
            this.saldos = res.data.data;
          }
        });
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getSaldosContas();
    this.carregando = false;
  },
};
</script>

<style scoped>
.lm-dialog {
  overflow: hidden;
}

/* Header com "faixa" */
.lm-head {
  position: relative;
  padding: 18px 18px 14px 18px;
  background: linear-gradient(
    135deg,
    rgba(103, 58, 183, 0.12),
    rgba(103, 58, 183, 0.04)
  );
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lm-avatar {
  background: rgba(103, 58, 183, 0.12);
}

.lm-title {
  font-weight: 800;
  font-size: 1.05rem;
  line-height: 1.1;
}

.lm-subtitle {
  margin-top: 2px;
  opacity: 0.8;
  font-size: 0.9rem;
}

.lm-close {
  opacity: 0.8;
}

/* Destaque do mês atual */
.lm-highlight {
  padding: 14px 14px;
  border: 1px solid rgba(103, 58, 183, 0.16);
}

.lm-highlight-title {
  font-weight: 700;
  opacity: 0.8;
  font-size: 0.85rem;
}

.lm-highlight-date {
  font-weight: 900;
  font-size: 1.15rem;
  margin-top: 2px;
}

/* Seção */
.lm-section-title {
  font-weight: 800;
  font-size: 0.95rem;
  opacity: 0.9;
}

/* Timeline */
.lm-timeline {
  margin-top: 6px;
}

.lm-row {
  display: flex;
  gap: 12px;
  padding: 10px 0;
}

.lm-dot-wrap {
  position: relative;
  width: 18px;
  display: flex;
  justify-content: center;
}

.lm-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.18);
  margin-top: 4px;
}

.lm-dot--active {
  background: #673ab7; /* deep-purple base */
  box-shadow: 0 0 0 4px rgba(103, 58, 183, 0.15);
}

.lm-line {
  position: absolute;
  top: 18px;
  bottom: -10px;
  width: 2px;
  background: rgba(0, 0, 0, 0.08);
}

.lm-row-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.7);
}

.lm-row-title {
  font-weight: 700;
  font-size: 0.95rem;
}

.lm-row-date {
  font-weight: 900;
  margin-left: 6px;
}

.lm-chip {
  flex-shrink: 0;
}
</style>
